import React, { useState, useEffect } from 'react';
import { Plus, Trash2, Edit2, Check, X } from 'lucide-react';
import { getAuthorizedHeaders } from '../utils/authorizedHeaders';

const API_BASE = 'https://warngen-api-352514293915.europe-west1.run.app';


export default function EmisorManager({ usuario }) {
    const [emisores, setEmisores] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [editandoId, setEditandoId] = useState(null);
    const [formNuevo, setFormNuevo] = useState({ nombre: '', email: '' });
    const [formEdicion, setFormEdicion] = useState({ nombre: '', email: '' });
    const [error, setError] = useState('');
    const esAdmin = usuario?.rol === 'admin' || usuario?.rol === 'superadmin';

    const cargar = async () => {
        setCargando(true);
        try {
            const res = await fetch(API_BASE + '/api/emisores', { headers: getAuthorizedHeaders() });
            const data = await res.json();
            if (data.success) setEmisores(data.data);
        } catch (e) { setError('Error cargando emisores'); }
        setCargando(false);
    };
    useEffect(() => { cargar(); }, []);

    const crear = async () => {
        if (!formNuevo.nombre.trim() || !formNuevo.email.trim()) { setError('Nombre y email son obligatorios'); return; }
        try {
            const res = await fetch(API_BASE + '/api/emisores', { method: 'POST', headers: getAuthorizedHeaders(), body: JSON.stringify(formNuevo) });
            const data = await res.json();
            if (data.success) { setFormNuevo({ nombre: '', email: '' }); setError(''); cargar(); }
            else setError(data.error || 'Error al crear emisor');
        } catch (e) { setError('Error al crear emisor'); }
    };

    const guardarEdicion = async (id) => {
        try {
            const res = await fetch(API_BASE + '/api/emisores/' + id, { method: 'PUT', headers: getAuthorizedHeaders(), body: JSON.stringify({ ...formEdicion, activo: true }) });
            const data = await res.json();
            if (data.success) { setEditandoId(null); cargar(); } else setError(data.error || 'Error al guardar');
        } catch (e) { setError('Error al guardar emisor'); }
    };

    const eliminar = async (id) => {
        if (!window.confirm('Eliminar este emisor?')) return;
        try {
            const res = await fetch(API_BASE + '/api/emisores/' + id, { method: 'DELETE', headers: getAuthorizedHeaders() });
            const data = await res.json();
            if (data.success) cargar(); else setError(data.error || 'Error al eliminar');
        } catch (e) { setError('Error al eliminar emisor'); }
    };

    return (
        <div className="space-y-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-1">Emisores de Email</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">Remitentes disponibles al enviar alertas. El receptor vera el nombre en el campo De.</p>
                {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">{error}</div>}
                {cargando ? <div className="text-center py-8 text-gray-400">Cargando...</div> : (
                    <table className="w-full text-sm">
                        <thead><tr className="border-b dark:border-gray-700">
                            <th className="text-left py-2 px-3 text-gray-600 dark:text-gray-400 font-semibold">Nombre visible</th>
                            <th className="text-left py-2 px-3 text-gray-600 dark:text-gray-400 font-semibold">Email</th>
                            {esAdmin && <th className="py-2 px-3 w-20"></th>}
                        </tr></thead>
                        <tbody>
                            {emisores.length === 0 && <tr><td colSpan={3} className="text-center py-6 text-gray-400">No hay emisores configurados</td></tr>}
                            {emisores.map(e => (
                                <tr key={e.id} className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition">
                                    {editandoId === e.id ? (
                                        <>
                                            <td className="py-2 px-3"><input className="border dark:border-gray-600 rounded px-2 py-1 text-sm w-full dark:bg-gray-700 dark:text-gray-100" value={formEdicion.nombre} onChange={ev => setFormEdicion({ ...formEdicion, nombre: ev.target.value })} /></td>
                                            <td className="py-2 px-3"><input className="border dark:border-gray-600 rounded px-2 py-1 text-sm w-full dark:bg-gray-700 dark:text-gray-100" value={formEdicion.email} onChange={ev => setFormEdicion({ ...formEdicion, email: ev.target.value })} /></td>
                                            <td className="py-2 px-3"><div className="flex gap-2 justify-end"><button onClick={() => guardarEdicion(e.id)} className="text-green-600 hover:text-green-700"><Check size={16} /></button><button onClick={() => setEditandoId(null)} className="text-gray-400 hover:text-gray-600"><X size={16} /></button></div></td>
                                        </>
                                    ) : (
                                        <>
                                            <td className="py-2 px-3 font-medium text-gray-800 dark:text-gray-100">{e.nombre}</td>
                                            <td className="py-2 px-3 text-gray-500 dark:text-gray-400 font-mono text-xs">{e.email}</td>
                                            {esAdmin && <td className="py-2 px-3"><div className="flex gap-2 justify-end"><button onClick={() => { setEditandoId(e.id); setFormEdicion({ nombre: e.nombre, email: e.email }); }} className="text-blue-500 hover:text-blue-700"><Edit2 size={15} /></button><button onClick={() => eliminar(e.id)} className="text-red-400 hover:text-red-600"><Trash2 size={15} /></button></div></td>}
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                {esAdmin && (
                    <div className="mt-6 pt-6 border-t dark:border-gray-700">
                        <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">Anadir emisor</h4>
                        <div className="flex gap-3 flex-wrap">
                            <input type="text" placeholder="Nombre visible" className="border dark:border-gray-600 rounded-lg px-3 py-2 text-sm flex-1 min-w-[180px] dark:bg-gray-700 dark:text-gray-100" value={formNuevo.nombre} onChange={e => setFormNuevo({ ...formNuevo, nombre: e.target.value })} />
                            <input type="email" placeholder="Email del emisor" className="border dark:border-gray-600 rounded-lg px-3 py-2 text-sm flex-1 min-w-[220px] dark:bg-gray-700 dark:text-gray-100" value={formNuevo.email} onChange={e => setFormNuevo({ ...formNuevo, email: e.target.value })} />
                            <button onClick={crear} className="flex items-center gap-2 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition text-sm font-medium"><Plus size={16} /> Anadir</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}